import React from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../i18n/LocaleContext'

const NotFoundPage: React.FC = () => {
  const { t } = useLocale()

  return (
    <main className="lp-page nf-page">
      <p className="lp-kicker">404</p>
      <h1>{t('notfound.title')}</h1>
      <p className="lp-subtitle">{t('notfound.body')}</p>
      <div className="lp-actions">
        <Link className="btn btn-primary" to="/">
          {t('notfound.home')}
        </Link>
      </div>
    </main>
  )
}

export default NotFoundPage
